import { createAction } from '@reduxjs/toolkit';

export const openInfoPopup = createAction<{
  text: string;
  type: 'success' | 'error' | 'chat';
  callback?: () => void;
}>('infoPopup/open');
export const closeInfoPopup = createAction('infoPopup/close');
